
import { useHistory } from 'react-router-dom';
import '../App.css';
import './Login.css';
import Pfooter from '../Pfooter';
import { useState } from 'react';
import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GlobalVariable from '../GlobalVariable';
import ApiHandler from '../ApiHandler';
import { useDispatch } from 'react-redux';
import { userActions } from '../store/user-slice';
import LoginHeader from './LoginHeader';
import BranchSwitch from './BranchSwitch';





export default function Customer() {
    const dispatch = useDispatch();
    const [data, setData] = useState({ username: "", password: "", });

    const changeHandler = (e) => {
        setData({ ...data, [e.target.name]: e.target.value })
    }





    const history = useHistory();

    async function checkUser(e) {
        e.preventDefault();
        let item = {
            userId: data.username,
            password: data.password,
            wclientid: GlobalVariable.wcClient.toString(),
        };
        // let token="";
        ApiHandler.post({
            url: "api/Cust/Authenticate/AuthTokenCust/",
            data: item,
        }
        )
            .then(((result) => {
                console.log(result.data.token)
                if (result.data.isSuccess) {
                    window.localStorage.setItem("app-type", "Cust");
                    // the id typed at sign-in: Pending Bills sends it as
                    // `code`, and the auth response does not echo it back
                    window.localStorage.setItem("user-id", data.username);
                    dispatch(userActions.setLogin(true));
 
                    localStorage.setItem('user-info', JSON.stringify(result.data))
                    setTimeout(() => {
                        history.push("/components/customer/CustomerDashboard")

                    },);

                    // window.localStorage.setItem('loggedIn', true);
                }
                else {
                    throw result.data;
                }
            }))
            .catch(err => {
                toast.error("wrong username or password");
                console.error(err);
                if (err.response && err.response.status && err.response.status === 401) {
                    console.log(err.response);
                    //   RefreshTokenHandler();
                    //  ToastError("Token has expired Please refresh");
                }
            })


    }



    return (

        <div className="loginShell">
            <LoginHeader />


            <div className='loginPage'>
                <form onSubmit={checkUser} className='w-100'>
                    <div className='row m-0'>
                        <div className='col-xl-4 offset-xl-4 col-lg-6 offset-lg-3 col-md-8 offset-md-2 p-3'>
                            <div className='loginCard loginCardMain'>
                                <div className='loginBranchRibbon'>UDUPI HEAD BRANCH</div>
                                <BranchSwitch type='Customer' active='main' />
                                <div className='loginCardHead'>
                                    <h5 className='loginCardTitle'>Customer Login</h5>
                                    <p className='loginCardSub'>Sign in to place orders and view reports</p>
                                </div>
                                <div className='loginCardBody'>

                                    <label htmlFor='username'>Customer Id</label>
                                    <input
                                        id='username'
                                        name="username"
                                        onChange={changeHandler}
                                        value={data.username}
                                        type="text"
                                        autoComplete='username'
                                        className='form-control'
                                        placeholder='Enter your customer ID' />

                                    <label htmlFor='password'>Password</label>
                                    <input
                                        id='password'
                                        onChange={changeHandler}
                                        name="password"
                                        value={data.password}
                                        type="password"
                                        autoComplete='current-password'
                                        className='form-control'
                                        placeholder='Enter your password' />

                                    <button
                                        type="submit"
                                        className='loginBtn'
                                    >Sign In</button>

                                    <p className='loginHint'>
                                        Trouble signing in? Contact your Sarvodaya representative.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>


            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover

            />



            <Pfooter />
        </div>
    )
}


